<template>
    <GiVendorCommit :useSerialNumber="true" />
</template>

<script>
import GiVendorCommit from "../components/GiVendorCommit.vue";

export default {
    components: {
        GiVendorCommit,
    },
}
</script>
